import React from 'react';
import { Outlet } from 'react-router';
import PreviewModeToggleNavigation from 'router/subrouters/ListingCreationWizard/components/PreviewModeToggleNavigation';
import PreviewPatchListingProvider from 'router/subrouters/ListingCreationWizard/providers/PreviewPatchListing';

const ProfitableGoingConcern: React.FC = () => {
  return (
    <PreviewPatchListingProvider>
      <PreviewModeToggleNavigation />
      <Outlet />
    </PreviewPatchListingProvider>
  );
};

export default ProfitableGoingConcern;
